export enum EnumPartnerSegment {
  BENEFIT_MANAGER = "Gestor de Benefício",
  CONSULTANCY = "Consultorias",
  ACCOUNTING = "Contabilidade",
  INSURANCE = "Seguros",
  HR_SOLUTIONS = "Soluções para RH",
  TECHNOLOGY_SOLUTIONS = "Soluções de tecnologia",
  FINANCIAL_PRODUCTS = "Produtos financeiros",
  OTHERS = "Outros",
}
